import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_gE1aiWVoBad8: {
	id: 'prd_gE1ai2DEV2WVoBad8'
	ident: 'prd_gE1aiWVoBad8'
	sku: 'simple_premium_1w_3_53_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_XTt7N2DEV2Ar6J5Ow'
			amount: 22
			amount_usd: 3.53
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 3.53
			discount: 18.47
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_zUJZ72DEV2QX3HxKU'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_gE1aiWVoBad8, SubscriptionProduct>
const prd_gE1aiWVoBad8 = { ident: 'prd_gE1aiWVoBad8' } as typeof _prd_gE1aiWVoBad8

export default prd_gE1aiWVoBad8
